<template>
  <div>
    <v-card v-if="isBusy" flat>
      <div class="d-flex flex-column align-items-center mt-8 py-6">
        <cube></cube>
        <p class="c-purple font-weight-bold mt-4">در حال بارگذاری اطلاعات...</p>
      </div>
    </v-card>
    <div class="animated fadeIn" v-else>
      <loading v-if="vLoading" />
      <!-- return-modal -->
      <v-dialog v-model="returnModal" width="600">
        <v-card class="modal-card">
          <h5 class="dark-grey-color py-5">
            <v-icon color="error">$Alert</v-icon>
            <span class="ps-2 pe-2 pt-1"
              >آیا از برگشت فاکتور {{ selected.invoiceCode }} از فروش اطمینان
              دارید؟</span
            >
          </h5>
          <div class="text-left mt-9">
            <v-btn
              class="purple-mainBtn"
              :loading="busy"
              @click="submitReturn"
              width="90"
              >بله</v-btn
            >
            <v-btn
              class="red-borderedBtn ms-2"
              @click="returnModal = false"
              width="90"
              >خیر</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
      <!-- convert dialog -->
      <v-dialog v-model="convertModal" width="700">
        <v-card class="shop-dialog">
          <v-card-title class="white">
            <v-row>
              <v-col cols="10">
                <h4 class="c-grey mb-0">
                  تبدیل پیش فاکتور {{ selected.invoiceCode }} به فروش
                </h4>
              </v-col>
              <v-col class="text-left pt-2">
                <span class="pointer" @click="convertModal = false"
                  ><v-icon class="close-icon">$Close</v-icon></span
                >
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mt-2 mb-8" />
          <v-card-text class="custom-input">
            <h5 class="mb-4">نوع فروش را انتخاب کنید:</h5>
            <v-row>
              <v-col cols="12">
                <v-select
                  label="نوع فروش"
                  :items="sellingTypes"
                  v-model="convert.sellingType"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" v-if="convert.sellingType == 'definite'">
                <v-select
                  label="نحوه پرداخت"
                  @change="cheque = {}"
                  :items="paymentTypes"
                  v-model="convert.paymentType"
                  outlined
                  dense
              /></v-col>
            </v-row>
            <div
              v-if="convert.paymentType == 'cheque'"
              class="pa-5 pt-10 my-6"
              style="
                border: 1px solid #ccc;
                border-radius: 15px;
                position: relative;
              "
            >
              <p
                class="ps-4 pe-4"
                style="position: absolute; top: -9px; background-color: #fff"
              >
                اطلاعات چک را وارد کنید:
              </p>
              <v-row>
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    type="number"
                    label="* شماره چک"
                    v-model="cheque.number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="* نام بانک"
                    v-model="cheque.bankName"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="6" cols="12">
                  <div>
                    <span id="chequeDate">
                      <v-text-field
                        outlined
                        dense
                        type="text"
                        append-icon="mdi-calendar-edit"
                        v-model="cheque.date"
                        label="تاریخ چک"
                        :editable="true"
                      >
                      </v-text-field>
                    </span>

                    <date-picker
                      v-model="cheque.date"
                      element="chequeDate"
                      color="#9c7fb7"
                    />
                  </div>
                </v-col>
                <v-col sm="6" cols="12">
                  <v-text-field
                    type="number"
                    class="rounded-lg"
                    label="شماره صیاد"
                    v-model="cheque.chequeSayyad"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <div v-if="computedchequeInfo" class="d-flex flex-row mt-2">
                <v-icon class="red--text me-1">mdi-alert-circle-outline</v-icon>
                <span class="red--text"
                  >وارد کردن شماره چک، نام بانک و تاریخ چک الزامی است.</span
                >
              </div>
            </div>
            <div
              v-if="convert.paymentType == 'cardTransfer'"
              class="pa-5 pt-8 my-6"
              style="
                border: 1px solid #ccc;
                border-radius: 15px;
                position: relative;
              "
            >
              <p
                class="ps-4 pe-4"
                style="position: absolute; top: -9px; background-color: #fff"
              >
                اطلاعات کارت‌ها:
              </p>
              <v-row>
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="شماره کارت فرستنده"
                    v-model="buyerCardNumber"
                    outlined
                    dense
                    class="rounded-lg"
                    data-maxlength="16"
                    oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                  ></v-text-field>
                </v-col>

                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="شماره کارت گیرنده"
                    v-model="recipientCardNumber"
                    outlined
                    dense
                    class="rounded-lg"
                    data-maxlength="16"
                    oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col>
                <v-textarea
                  outlined
                  dense
                  label="توضیحات"
                  v-model="convert.description"
                ></v-textarea
              ></v-col>
            </v-row>

            <div class="text-left mt-3">
              <v-btn
                class="purple-mainBtn"
                width="90"
                :loading="busy"
                @click="submitConvert"
                :disabled="computedBtn"
                >ثبت</v-btn
              >
              <v-btn
                class="red-borderedBtn ms-2"
                width="90"
                @click="
                  convertModal = false;
                  convert.description = '';
                "
                >لغو</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- expire dialog -->
      <v-dialog v-model="deleteDialog" width="600">
        <v-card class="modal-card">
          <h5 class="dark-grey-colo py-5">
            <v-icon color="error">$Alert</v-icon>
            <span class="ps-2 pe-2 pt-1"
              >آیا از منقضی کردن پیش‌ فاکتور
              {{ deletedItem.invoiceCode }} اطمینان دارید؟</span
            >
          </h5>
          <div class="text-left mt-9">
            <v-btn class="purple-mainBtn" width="90" @click="expire()"
              >بله</v-btn
            >
            <v-btn
              class="red-borderedBtn ms-2"
              width="90"
              @click="deleteDialog = false"
              >بازگشت</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
      <!-- payment-dialog -->
      <new-payment
        v-if="newPaymentOpen"
        :dialog="newDialog"
        :userId="userId"
        :userName="customer.name"
        @submitPayment="addPayment()"
        @closeDialog="closeNewPayment()"
      />

      <!-- editPayment-dialog -->
      <payment-details
        v-if="editPaymentOpen"
        :selectedId="selectedId"
        :userId="userId"
        :detailsDialog="detailsDialog"
        @closeDetailsDialog="closeDetailsDialog()"
        @submitEditDialog="submitEditDialog()"
      />

      <v-card
        v-if="$router.currentRoute.path == '/shop/customer/' + $route.params.id"
        class="common-card pa-4"
      >
        <div class="d-flex flex-row">
          <h4 class="c-grey ps-2 pt-4 pb-0">پروفایل مشتری</h4>
        </div>
        <hr class="mt-5" />
        <b-card
          style="border-radius: 10px"
          class="h-100 mt-6"
          :class="customer.customer_priority"
        >
          <b-row>
            <b-col cols="6">
              <div class="py-3 ps-4 pe-4">
                <!-- <h4 class="mb-5">
                  سطح‌بندی مشتری:
                  <img :src="computedIcon(customer.royaltyTier)" />
                  {{
                    customer.royaltyTier == "coper"
                      ? "برنزی"
                      : customer.royaltyTier == "silver"
                      ? "نقره‌ای"
                      : customer.royaltyTier == "gold"
                      ? "طلایی"
                      : customer.royaltyTier == "diamond"
                      ? "الماس"
                      : "-"
                  }}
                </h4> -->
                <h4>نام مشتری: {{ customer.name }}</h4>
                <h4 class="mb-10">تراز مالی: {{ balance }}</h4>
                <h5>نوع مشتری: {{ customer.type }}</h5>
                <h5>کد: {{ customer.customerCode }}</h5>
              </div></b-col
            >
            <b-col cols="6">
              <div class="py-3 ps-4 pe-4">
                <h5 class="mb-4">جمع کل خریدها: {{ totalInvoice }}</h5>
                <h5 class="mb-4">تعداد کل خریدها: {{ invoicesTotalRows }}</h5>
                <h5 class="mb-4">جمع کل پرداخت‌ها: {{ totalPayment }}</h5>
                <h5 class="mb-4">تعداد کل پرداخت‌ها: {{ incomesTotalRows }}</h5>
                <!-- <h5 class="mb-4">
                  میزان اعتبار ویژه: {{ vipRoyaltyCreditAmount }} ریال
                </h5>
                <h5 class="mb-4">
                  میزان اعتبار معمولی: {{ normalRoyaltyCreditAmount }} ریال
                </h5> -->
              </div></b-col
            >
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12">
              <div class="ps-4 pe-4 mt-2">
                <h5>
                  <v-icon class="me-1">$Phone</v-icon>
                  موبایل:
                  {{ customer.mobile ? customer.mobile : "-" }}
                </h5>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <v-tabs v-model="tab">
          <v-tab
            @click="
              filter = '';
              perPage = 10;
            "
          >
            فاکتورها
          </v-tab>
          <v-tab
            @click="
              filter = '';
              perPage = 10;
            "
          >
            پرداخت‌ها
          </v-tab>
          <v-tab
            @click="
              filter = '';
              perPage = 10;
            "
          >
            پیش فاکتور‌ها
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card flat>
              <v-container>
                <v-row class="pt-1 mb-2 ps-1 pe-1">
                  <v-col class="d-flex flex-row">
                    <h4 class="c-purple">فاکتورها</h4>
                    <span style="padding-top: 2px" class="c-grey ms-4"
                      >({{ customer.shopInvoices.length }} فاکتور)</span
                    >
                  </v-col>
                </v-row>
                <div class="custom-input">
                  <v-text-field
                    v-model="filter"
                    outlined
                    dense
                    prepend-inner-icon="$Search"
                    placeholder="جستجو در کد فاکتور"
                  >
                    <template v-if="filter.length" v-slot:append>
                      <div @click="filter = ''" class="pointer">
                        <v-icon color="red">mdi-close-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </div>
                <v-divider class="mt-2"></v-divider>

                <vue-excel-xlsx
                  :data="customer.shopInvoices"
                  :columns="excelInvoiceFields"
                  :file-name="`فاکتورهای مشتری ${customer.name}`"
                  :sheet-name="`فاکتوهای مشتری ${customer.name}`"
                  class="darkGreen-mainBtn mb-4 float-start"
                  style="width: 135px; height: 35px"
                  depressed
                  :class="
                    customer.shopInvoices.length
                      ? 'white--text '
                      : 'disabled-excel'
                  "
                >
                  <v-icon
                    class="me-1"
                    :class="customer.shopInvoices.length ? 'white--text' : ''"
                    >mdi-file-excel-outline</v-icon
                  >
                  خروجی اکسل
                </vue-excel-xlsx>

                <v-btn
                  :disabled="!customer.shopInvoices.length"
                  class="darkRed-mainBtn white--text mb-4 float-end"
                  style="width: 135px; height: 35px"
                  depressed
                  @click="
                    receiptType = 'total';
                    printReceipt();
                  "
                  ><v-icon class="me-1 white--text">mdi-printer</v-icon
                  >پرینت</v-btn
                >

                <div class="custom-table">
                  <b-table
                    responsive
                    show-empty
                    stacked="sm"
                    :current-page="invoicesCurrentPage"
                    :per-page="perPage"
                    :items="computedInvoiceCustomer"
                    :fields="invoiceFields"
                    :filter="filter"
                    empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                    empty-text="رکوردی برای نمایش وجود ندارد."
                    striped
                    thead-class="headClass"
                    tbody-class="bodyClass"
                    :busy="isBusy"
                    @filtered="onFilteredInvoices"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(invoiceCode)="data">
                      <div style="text-align: center; vertical-align: middle">
                        <a
                          target="_blank"
                          :href="'/shop/invoice/' + data.item.id"
                          >{{ data.value }}</a
                        >
                      </div>
                    </template>
                    <template v-slot:cell(royaltyDiscount)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() + " ریال" }}
                      </div>
                    </template>
                    <template v-slot:cell(useRoyaltyCredit)="data">
                      <div
                        style="
                          text-align: center;
                          vertical-align: middle;
                          min-width: 80px;
                          max-width: 120px;
                        "
                      >
                        <v-icon class="green--text me-1" v-if="data.value"
                          >mdi-check-decagram</v-icon
                        >
                        {{ data.value ? "استفاده شد" : "استفاده نشد" }}
                      </div>
                    </template>
                    <template v-slot:cell(operation)="row">
                      <div
                        style="text-align: center; vertical-align: middle"
                        class="pt-0"
                      >
                        <v-btn
                          v-if="!row.item._showDetails"
                          @click="row.toggleDetails"
                          class="purple-mainBtn"
                          width="120"
                          >نمایش عملیات</v-btn
                        >
                        <v-btn
                          v-else
                          @click="row.toggleDetails"
                          class="red-mainBtn"
                          width="120"
                          >بستن عملیات</v-btn
                        >
                      </div>
                    </template>
                    <template #row-details="row">
                      <div
                        class="animated fadeIn mb-2"
                        style="text-align: center; vertical-align: middle"
                      >
                        <v-btn
                          color="purple-mainBtn"
                          class="me-1 mb-1"
                          width="140"
                          @click="printInvoiceReceipt(row.item)"
                        >
                          <v-icon class="me-1">mdi-printer</v-icon>

                          چاپ رسید
                        </v-btn>
                        <v-btn
                          v-if="
                            row.item.status != 'برگشت خورده' &&
                            row.item.type != 'مرجوعی'
                          "
                          width="140"
                          class="red-mainBtn ms-1 mb-1"
                          @click="openReturnModal(row.item)"
                        >
                          <v-icon class="me-1">mdi-logout-variant</v-icon>
                          ابطال فاکتور
                        </v-btn>
                      </div>
                    </template>

                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          data.index + 1 + perPage * (invoicesCurrentPage - 1)
                        }}
                      </div>
                    </template>
                    <div
                      slot="table-isBusy"
                      class="text-center text-danger my-2"
                    >
                      <strong>در حال بارگذاری...</strong>
                      <br />
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </b-table>
                  <v-row class="mt-6" v-if="!isBusy && invoicesTotalRows">
                    <v-col>
                      <v-col class="d-flex flex-row">
                        <span class="c-grey pt-2">نمایش در هر صفحه</span>
                        <div class="ms-3 me-3 number-box">
                          <v-select
                            attach
                            class="shop-select"
                            :menu-props="{ top: true, offsetY: true }"
                            outlined
                            v-model="perPage"
                            :items="perPageOptions"
                            @change="invoicesCurrentPage = 1"
                          ></v-select>
                        </div>
                      </v-col>
                    </v-col>
                    <v-col>
                      <div>
                        <v-pagination
                          v-model="invoicesCurrentPage"
                          :length="
                            Math.ceil(computedInvoiceCustomer.length / perPage)
                          "
                          :total-visible="5"
                          prev-icon="$ArrowLeft"
                          next-icon="$ArrowRight"
                          class="float-end"
                        ></v-pagination>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-container>
                <v-row class="pt-1 mb-2 ps-1 pe-1">
                  <v-col class="d-flex flex-row">
                    <h4 class="c-purple">پرداخت‌ها</h4>
                    <span style="padding-top: 2px" class="c-grey ms-4"
                      >({{ customer.shopIncomes.length }} پرداخت)</span
                    >
                  </v-col>
                  <v-col class="text-left">
                    <v-btn
                      @click="openPayModal()"
                      class="purple-borderedBtn mb-4"
                      height="43"
                      style="text-decoration: none"
                    >
                      <v-icon class="me-1">$Wallet</v-icon>افزودن پرداخت جدید
                    </v-btn>
                  </v-col>
                </v-row>
                <div class="custom-input">
                  <v-text-field
                    v-model="filter"
                    outlined
                    dense
                    prepend-inner-icon="$Search"
                    placeholder="جستجوی پرداخت"
                  >
                    <template v-if="filter.length" v-slot:append>
                      <div @click="filter = ''" class="pointer">
                        <v-icon color="red" style="margin-top: 1px"
                          >mdi-close-circle-outline</v-icon
                        >
                      </div>
                    </template>
                  </v-text-field>
                </div>
                <v-divider class="mt-2"></v-divider>
                <v-btn
                  class="darkRed-mainBtn white--text float-end"
                  style="width: 135px; height: 35px"
                  @click="
                    receiptType = 'total2';
                    printReceipt();
                  "
                  depressed
                  :disabled="!customer.shopIncomes.length"
                  ><v-icon class="me-1 white--text">mdi-printer</v-icon
                  >پرینت</v-btn
                >
                <vue-excel-xlsx
                  :data="customer.shopIncomes"
                  :columns="excelPaymentFields"
                  :file-name="`پرداخت‌های مشتری ${customer.name}`"
                  :sheet-name="`پرداخت‌های مشتری ${customer.name}`"
                  class="darkGreen-mainBtn mb-4 float-start"
                  style="width: 135px; height: 35px"
                  depressed
                  :class="
                    customer.shopIncomes.length
                      ? 'white--text'
                      : 'disabled-excel'
                  "
                >
                  <v-icon
                    :class="customer.shopIncomes.length ? 'white--text' : ''"
                    class="me-1"
                    >mdi-file-excel-outline</v-icon
                  >
                  خروجی اکسل
                </vue-excel-xlsx>

                <div class="custom-table">
                  <b-table
                    responsive
                    show-empty
                    :items="computedShopIncomes"
                    :fields="paymentFields"
                    empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    striped
                    thead-class="headClass"
                    tbody-class="bodyClass"
                    :current-page="incomesCurrentPage"
                    :per-page="perPage"
                    :busy="isBusy"
                    :filter="filter"
                    @filtered="onFilteredIncomes"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          data.index + 1 + perPage * (incomesCurrentPage - 1)
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(description)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          data.value.length > 40
                            ? data.value.slice(0, 40) + "..."
                            : data.value
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(operation)="row">
                      <div
                        style="text-align: center; vertical-align: middle"
                        class="pt-0"
                      >
                        <v-btn
                          v-if="!row.item._showDetails"
                          @click="row.toggleDetails"
                          class="purple-mainBtn"
                          width="120"
                          >نمایش عملیات</v-btn
                        >
                        <v-btn
                          v-else
                          @click="row.toggleDetails"
                          class="red-mainBtn"
                          width="120"
                          >بستن عملیات</v-btn
                        >
                      </div>
                    </template>
                    <template #row-details="row">
                      <div
                        class="animated fadeIn mb-2"
                        style="text-align: center; vertical-align: middle"
                      >
                        <v-btn
                          class="purple-mainBtn ms-1"
                          @click="paymentPrint(row.item)"
                          width="135"
                          height="40"
                        >
                          <v-icon class="me-1">mdi-printer</v-icon>
                          چاپ رسید
                        </v-btn>
                        <v-btn
                          @click="openDetailsDialog(row.item.id)"
                          class="green-mainBtn ms-1"
                          width="135"
                          height="40"
                          ><v-icon class="me-1">mdi-eye</v-icon>مشاهده
                          جزئیات</v-btn
                        >
                      </div>
                    </template>
                    <div
                      slot="table-isBusy"
                      class="text-center text-danger my-2"
                    >
                      <strong>در حال بارگذاری...</strong>
                      <br />
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </b-table>
                  <v-row class="mt-6" v-if="!isBusy && incomesTotalRows">
                    <v-col class="d-flex flex-row">
                      <span class="c-grey pt-2">نمایش در هر صفحه</span>
                      <div class="ms-3 me-3 number-box">
                        <v-select
                          attach
                          class="shop-select"
                          :menu-props="{ top: true, offsetY: true }"
                          outlined
                          v-model="perPage"
                          :items="perPageOptions"
                          @change="incomesCurrentPage = 1"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col>
                      <div>
                        <v-pagination
                          v-model="incomesCurrentPage"
                          :length="
                            Math.ceil(computedShopIncomes.length / perPage)
                          "
                          :total-visible="5"
                          prev-icon="$ArrowLeft"
                          next-icon="$ArrowRight"
                          class="float-end"
                        ></v-pagination>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-container>
                <v-row class="pt-1 mb-2 ps-1 pe-1">
                  <v-col class="d-flex flex-row">
                    <h4 class="c-purple">پیش فاکتورها</h4>
                    <span style="padding-top: 2px" class="c-grey ms-4"
                      >({{ customer.proformaInvoices.length }} پیش فاکتور)</span
                    >
                  </v-col>
                </v-row>
                <div class="custom-input">
                  <v-text-field
                    v-model="filter"
                    outlined
                    dense
                    prepend-inner-icon="$Search"
                    placeholder="جستجوی پیش فاکتور"
                  >
                    <template v-if="filter.length" v-slot:append>
                      <div @click="filter = ''" class="pointer">
                        <v-icon color="red" style="margin-top: 1px"
                          >mdi-close-circle-outline</v-icon
                        >
                      </div>
                    </template>
                  </v-text-field>
                </div>
                <v-divider class="mt-2"></v-divider>

                <vue-excel-xlsx
                  :data="customer.proformaInvoices"
                  :columns="excelProformaInvoiceFields"
                  :file-name="`پیش فاکتورهای مشتری ${customer.name}`"
                  :sheet-name="`پیش فاکتورهای مشتری ${customer.name}`"
                  class="darkGreen-mainBtn mb-4 float-start"
                  style="width: 135px; height: 35px"
                  depressed
                  :class="
                    customer.proformaInvoices.length
                      ? 'white--text'
                      : 'disabled-excel'
                  "
                >
                  <v-icon
                    :class="
                      customer.proformaInvoices.length ? 'white--text' : ''
                    "
                    class="me-1"
                    >mdi-file-excel-outline</v-icon
                  >
                  خروجی اکسل
                </vue-excel-xlsx>

                <v-btn
                  class="darkRed-mainBtn white--text float-end mb-4"
                  style="width: 135px; height: 35px"
                  @click="
                    receiptType = 'total3';
                    printReceipt();
                  "
                  depressed
                  :disabled="!customer.proformaInvoices.length"
                  ><v-icon class="me-1 white--text">mdi-printer</v-icon
                  >پرینت</v-btn
                >

                <div class="custom-table">
                  <b-table
                    responsive
                    show-empty
                    :items="customer.proformaInvoices"
                    :fields="proformaInvoiceFields"
                    empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    striped
                    thead-class="headClass"
                    tbody-class="bodyClass"
                    :current-page="proformaCurrentPage"
                    :per-page="perPage"
                    :busy="isBusy"
                    :filter="filter"
                    @filtered="onFilteredProforma"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(invoiceCode)="data">
                      <div style="text-align: center; vertical-align: middle">
                        <a
                          target="_blank"
                          :href="'/shop/invoice/' + data.item.id"
                          >{{ data.value }}</a
                        >
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          data.index + 1 + perPage * (proformaCurrentPage - 1)
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(operation)="row">
                      <div
                        style="text-align: center; vertical-align: middle"
                        class="pt-0"
                      >
                        <v-btn
                          v-if="!row.item._showDetails"
                          @click="row.toggleDetails"
                          class="purple-mainBtn"
                          width="120"
                          >نمایش عملیات</v-btn
                        >
                        <v-btn
                          v-else
                          @click="row.toggleDetails"
                          class="red-mainBtn"
                          width="120"
                          >بستن عملیات</v-btn
                        >
                      </div>
                    </template>
                    <template #row-details="row">
                      <div
                        class="animated fadeIn mb-2"
                        style="text-align: center; vertical-align: middle"
                      >
                        <v-btn
                          class="ms-1 purple-mainBtn"
                          width="135"
                          height="40"
                          @click="printPreInvoice(row.item, 'preInvoice')"
                        >
                          <v-icon class="me-1">mdi-printer</v-icon>

                          چاپ رسید
                        </v-btn>
                        <v-btn
                          v-if="row.item.status != 'برگشت خورده'"
                          class="ms-1 green-mainBtn"
                          width="135"
                          height="40"
                          @click="openConvertModal(row.item)"
                        >
                          <v-icon class="me-1">mdi-refresh</v-icon>
                          تبدیل به فروش
                        </v-btn>
                        <v-btn
                          v-if="row.item.status != 'برگشت خورده'"
                          class="ms-1 red-mainBtn white--text"
                          width="135"
                          height="40"
                          @click="
                            deleteDialog = true;
                            deletedItem = row.item;
                          "
                        >
                          <v-icon class="me-1">mdi-logout-variant</v-icon>

                          منقضی کردن
                        </v-btn>
                      </div>
                    </template>

                    <div
                      slot="table-isBusy"
                      class="text-center text-danger my-2"
                    >
                      <strong>در حال بارگذاری...</strong>
                      <br />
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </b-table>
                  <v-row class="mt-6" v-if="!isBusy && proformaTotalRows">
                    <v-col class="d-flex flex-row">
                      <span class="c-grey pt-2">نمایش در هر صفحه</span>
                      <div class="ms-3 me-3 number-box">
                        <v-select
                          attach
                          class="shop-select"
                          :menu-props="{ top: true, offsetY: true }"
                          outlined
                          v-model="perPage"
                          :items="perPageOptions"
                          @change="proformaCurrentPage = 1"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col>
                      <div>
                        <v-pagination
                          v-model="proformaCurrentPage"
                          :length="
                            Math.ceil(
                              customer.proformaInvoices.length / perPage
                            )
                          "
                          :total-visible="5"
                          prev-icon="$ArrowLeft"
                          next-icon="$ArrowRight"
                          class="float-end"
                        ></v-pagination>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <br />
        <!-- receipt -->
        <v-card
          class="pa-2"
          style="direction: rtl"
          v-show="false"
          id="proformaList"
        >
          <b-card
            style="border: 1px solid black; border-radius: 15px; padding: 10px"
          >
            <table style="border: 0px solid black !important">
              <tr>
                <td style="border: 0px solid black !important">
                  <span>نام مشتری: {{ customer.name }}</span>
                </td>
                <td style="border: 0px solid black !important">
                  <span>نوع مشتری: {{ customer.type }}</span>
                </td>
              </tr>
              <tr>
                <td style="border: 0px solid black !important">
                  <span>کد: {{ customer.customerCode }}</span>
                </td>
                <td style="border: 0px solid black !important">
                  <span
                    >موبایل: {{ customer.mobile ? customer.mobile : "-" }}</span
                  >
                </td>
              </tr>
            </table>
          </b-card>
          <br />
          <hr />
          <br />
          <b-card
            header-bg-variant="primary"
            header-text-variant="white"
            v-if="customer.proformaInvoices"
          >
            <template v-slot:header>
              <h3>
                پیش فاکتورهای مشتری - {{ customer.proformaInvoices.length }} عدد
              </h3>
            </template>
            <b-table
              v-if="customer.proformaInvoices.length"
              :items="customer.proformaInvoices"
              :fields="receiptProformaInvoiceFields"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>
          </b-card>
        </v-card>
        <v-card
          class="pa-2"
          style="direction: rtl"
          v-show="false"
          id="paymentsList"
        >
          <b-card
            style="border: 1px solid black; border-radius: 15px; padding: 10px"
          >
            <table style="border: 0px solid black !important">
              <tr>
                <td style="border: 0px solid black !important">
                  <span>نام مشتری: {{ customer.name }}</span>
                </td>
                <td style="border: 0px solid black !important">
                  <span>نوع مشتری: {{ customer.type }}</span>
                </td>
              </tr>
              <tr>
                <td style="border: 0px solid black !important">
                  <span>کد: {{ customer.customerCode }}</span>
                </td>
                <td style="border: 0px solid black !important">
                  <span
                    >موبایل: {{ customer.mobile ? customer.mobile : "-" }}</span
                  >
                </td>
              </tr>
            </table>
          </b-card>
          <br />
          <hr />
          <br />
          <b-card
            header-bg-variant="primary"
            header-text-variant="white"
            v-if="customer.shopIncomes"
          >
            <template v-slot:header>
              <h3>پرداخت‌های مشتری - {{ customer.shopIncomes.length }} عدد</h3>
            </template>
            <b-table
              v-if="customer.shopIncomes.length"
              :items="customer.shopIncomes"
              :fields="receiptPaymentFields"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>
          </b-card>
        </v-card>
        <v-card
          class="pa-2"
          style="direction: rtl"
          v-show="false"
          id="invoicesList"
        >
          <b-card
            style="border: 1px solid black; border-radius: 15px; padding: 10px"
          >
            <table style="border: 0px solid black !important">
              <tr>
                <td style="border: 0px solid black !important">
                  <span>نام مشتری: {{ customer.name }}</span>
                </td>
                <td style="border: 0px solid black !important">
                  <span>نوع مشتری: {{ customer.type }}</span>
                </td>
              </tr>
              <tr>
                <td style="border: 0px solid black !important">
                  <span>کد: {{ customer.customerCode }}</span>
                </td>
                <td style="border: 0px solid black !important">
                  <span
                    >موبایل: {{ customer.mobile ? customer.mobile : "-" }}</span
                  >
                </td>
              </tr>
            </table>
          </b-card>
          <br />
          <hr />
          <br />
          <b-card
            header-bg-variant="primary"
            header-text-variant="white"
            v-if="customer.shopInvoices"
          >
            <template v-slot:header>
              <h3>فاکتورهای مشتری - {{ customer.shopInvoices.length }} عدد</h3>
            </template>
            <b-table
              v-if="customer.shopInvoices.length"
              :items="customer.shopInvoices"
              :fields="receiptInvoiceFields"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <!-- <template v-slot:cell(useRoyaltyCredit)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value == true ? "استفاده شد" : "استفاده نشد" }}
                </div>
              </template> -->
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>
          </b-card>
          <hr />
          <hr />

          <br />
          <hr />
          <br />

          <table
            style="border: 0px solid black !important; break-inside: avoid"
          >
            <tr>
              <td style="border: 0px solid black !important">
                <span>جمع کل خریدها: {{ totalInvoice }}</span>
              </td>
              <td style="border: 0px solid black !important">
                <span>تعداد کل خریدها: {{ invoicesTotalRows }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px solid black !important">
                <span>جمع کل پرداخت‌ها: {{ totalPayment }}</span>
              </td>
              <td style="border: 0px solid black !important">
                <span>تعداد کل پرداخت‌ها: {{ incomesTotalRows }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 0px solid black !important">
                <span>تراز مالی: {{ balance }}</span>
              </td>
            </tr>
          </table>
        </v-card>
        <v-card v-show="false" id="paymentReceipt">
          <div class="container mb-0" style="border: 1px solid black">
            <div
              style="
                text-align: center;
                width: 100%;
                border-bottom: 1px solid black;
              "
            >
              <span style="font-size: 18px">فروشگاه پولاد پیچ کار</span>
            </div>

            <div style="padding: 0 15px">
              <div style="direction: rtl">
                <div
                  style="
                    border: 1px solid black;
                    border-radius: 10px;
                    padding: 0 10px;
                    margin-bottom: 10px;
                    margin-top: 10px;
                  "
                >
                  <div style="text-align: center;">
                    <span>
                      رسید پرداخت (چاپ مجدد)
                    </span>
                  </div>
                  <br />
                  <div>
                    <table
                      style="
                        border: 0px solid black !important;
                        break-inside: avoid;
                      "
                    >
                      <tr>
                        <td style="border: 0px solid black !important">
                          نام مشتری:
                          {{ printPayment.shopCustomerName }}
                        </td>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: left;
                          "
                        >
                          تاریخ:
                          {{ printPayment.date }}
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 0px solid black !important">
                          کد مشتری:
                          {{ printPayment.shopCustomerCode }}
                        </td>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: left;
                          "
                        >
                          ساعت:
                          {{ printPayment.time }}
                        </td>
                      </tr>
                    </table>

                    <br />
                  </div>
                </div>
                <div style="padding: 0 10px">
                  <table
                    style="
                      border: 0px solid black !important;
                      break-inside: avoid;
                    "
                  >
                    <tr>
                      <td
                        v-if="printPayment.paymentType == 'cheque'"
                        style="border: 0px solid black !important"
                      >
                        <span
                          >شیوه پرداخت:
                          {{
                            paymentTypes.filter(
                              (x) => x.value == printPayment.paymentType
                            )[0]
                              ? paymentTypes.filter(
                                  (x) => x.value == printPayment.paymentType
                                )[0].text
                              : "-"
                          }}
                        </span>
                      </td>
                      <td
                        v-if="printPayment.paymentType == 'cheque'"
                        style="border: 0px solid black !important"
                      >
                        <span>{{ "شماره چک: " + printPayment.chequeNo }}</span>
                      </td>
                    </tr>
                    <tr v-if="printPayment.paymentType == 'cheque'">
                      <td style="border: 0px solid black !important">
                        <span>{{
                          "شماره صیاد: " + printPayment.chequeSayyad
                        }}</span>
                      </td>
                      <td style="border: 0px solid black !important">
                        <span>{{
                          "نام بانک: " + printPayment.chequeBank
                        }}</span>
                      </td>
                    </tr>
                    <tr v-if="printPayment.paymentType == 'cheque'">
                      <td style="border: 0px solid black !important">
                        <span>{{
                          "تاریخ چک: " + printPayment.chequeDate
                        }}</span>
                      </td>
                    </tr>
                    <tr v-if="printPayment.paymentType == 'cardTransfer'">
                      <td style="border: 0px solid black !important">
                        <span>{{
                          "شماره کارت فرستنده: " + printPayment.buyerCardNumber
                        }}</span>
                      </td>
                      <td style="border: 0px solid black !important;text-align:left">
                        <span>{{
                          "شماره کارت گیرنده: " + printPayment.recipientCardNumber
                        }}</span>
                      </td>
                    </tr>
                  </table>

                  <table style="border: 0px solid black !important">
                    <tr>
                      <td style="border: 0px solid black !important">
                        مبلغ پرداخت:
                        {{ Number(printPayment.amount).toLocaleString() }} ریال
                      </td>
                      <td
                        v-if="printPayment.paymentType != 'cheque'"
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                        "
                      >
                        <span
                          >نحوه پرداخت:
                          {{
                            paymentTypes.filter(
                              (x) => x.value == printPayment.paymentType
                            )[0]
                              ? paymentTypes.filter(
                                  (x) => x.value == printPayment.paymentType
                                )[0].text
                              : "-"
                          }}
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>
                <div
                  style="
                    border: 1px solid black;
                    border-radius: 10px;
                    min-height: 80px;
                    padding: 10px;
                    margin-top: 15px
                    break-inside: avoid
                  "
                >
                  <span>توضیحات: {{ printPayment.description ? printPayment.description : '-' }}</span>
                </div>
                <br />
              </div>
            </div>
          </div>
        </v-card>
      </v-card>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import VueCkeditor from "vue-ckeditor2";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import NewPayment from "../../components/NewPayment.vue";
import PaymentDetails from "../../components/PaymentDetails.vue";

export default {
  components: {
    VueCkeditor,
    datePicker: VuePersianDatetimePicker,
    NewPayment,
    PaymentDetails,
  },
  data: function () {
    return {
      gettingReceipt: true,
      editPaymentOpen: false,
      newPaymentOpen: false,
      tab: null,
      normalRoyaltyCreditAmount: null,
      vipRoyaltyCreditAmount: null,
      invoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ (ریال)" },
        { key: "type", label: "نوع فاکتور" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      excelInvoiceFields: [
        { field: "invoiceCode", label: "کد فاکتور" },
        { field: "date", label: "تاریخ" },
        { field: "time", label: "ساعت" },
        { field: "totalCost", label: "مبلغ (ریال)" },
        { field: "type", label: "نوع فاکتور" },
        { field: "status", label: "وضعیت" },
      ],
      receiptInvoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ (ریال)" },
        { key: "type", label: "نوع فاکتور" },
        { key: "status", label: "وضعیت" },
      ],
      proformaInvoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "expirationDate", label: "تاریخ اعتبار" },
        { key: "totalCost", label: "مبلغ (ریال)" },
        { key: "operation", label: "عملیات" },
      ],
      excelProformaInvoiceFields: [
        { field: "invoiceCode", label: "کد فاکتور" },
        { field: "date", label: "تاریخ" },
        { field: "time", label: "ساعت" },
        { field: "expirationDate", label: "تاریخ اعتبار" },
        { field: "totalCost", label: "مبلغ (ریال)" },
      ],
      receiptProformaInvoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "expirationDate", label: "تاریخ اعتبار" },
        { key: "totalCost", label: "مبلغ (ریال)" },
        // { key: "operation", label: "عملیات" }
      ],
      paymentFields: [
        { key: "index", label: "ردیف" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "type", label: "نحوه پرداخت" },
        { key: "description", label: "توضیحات" },
        { key: "amount", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      excelPaymentFields: [
        { field: "date", label: "تاریخ" },
        { field: "time", label: "ساعت" },
        { field: "type", label: "نحوه پرداخت" },
        { field: "description", label: "توضیحات" },
        { field: "amount", label: "مبلغ" },
        { field: "status", label: "وضعیت" },
      ],
      receiptPaymentFields: [
        { key: "index", label: "ردیف" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "description", label: "توضیحات" },
        { key: "amount", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
      ],
      selectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
        // { key: "sum", label: "موجودی" },
        // { key: "operation", label: "عملیات" },
      ],
      currentPage: 1,
      proformaCurrentPage: 1,
      invoicesCurrentPage: 1,
      incomesCurrentPage: 1,
      perPage: 10,
      isBusy: true,
      invoicesTotalRows: "",
      incomesTotalRows: "",
      proformaTotalRows: "",
      balance: "",
      content: "",
      filter: "",
      returnModal: false,
      sortBy: "",
      userInput: "",
      role: "",
      selected: "",
      agent: {},
      customer: "",
      invoiceType: "definite",
      invoiceTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
      totalInvoice: "",
      totalPayment: "",
      receiptType: "",
      printInvoice: {},
      printPayment: {
        shopCustomerName: "",
        shopCustomerCode: "",
        date: "",
        time: "",
        amount: null,
        paymentType: "",
        description: "",
        chequeBank: "",
        chequeSayyad: "",
        chequeNo: "",
        chequeDate: "",
      },
      convert: {},
      busy: false,
      cheque: {},
      convertModal: false,
      sellingTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
        { value: "cardTransfer", text: "کارت به کارت" },
      ],
      type: "reprint",
      userId: "",
      perPageOptions: [4, 10, 20],
      buyerCardNumber: "",
      recipientCardNumber: "",
      deletedItem: {},
      deleteDialog: false,
    };
  },

  methods: {
    openDetailsDialog(id) {
      this.editPaymentOpen = true;
      this.selectedId = id;
      this.detailsDialog = true;
    },
    openPayModal() {
      this.newDialog = true;
      this.newPaymentOpen = true;
    },
    addPayment() {
      this.newPaymentOpen = false;
      this.getCustomerInfo();
    },
    closeNewPayment() {
      this.newPaymentOpen = false;
    },
    submitEditDialog() {
      this.editPaymentOpen = false;
      this.getCustomerInfo();
    },
    closeDetailsDialog() {
      this.editPaymentOpen = false;
    },
    // computedIcon(item) {
    //   if (item == "coper") {
    //     return "/icons8-star-35(1).png";
    //   } else if (item == "silver") {
    //     return "/icons8-star-35.png";
    //   } else if (item == "gold") {
    //     return "/icons8-star-35(2).png";
    //   } else if (item == "diamond") {
    //     return "/icons8-diamond-35.png";
    //   }
    // },
    onFilteredInvoices(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.invoicesTotalRows = filteredItems.length;
      this.invoicesCurrentPage = 1;
    },
    onFilteredIncomes(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.incomesTotalRows = filteredItems.length;
      this.incomesCurrentPage = 1;
    },
    onFilteredProforma(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.proformaTotalRows = filteredItems.length;
      this.proformaCurrentPage = 1;
    },
    openReturnModal(item) {
      this.returnModal = true;
      this.selected = item;
    },
    openConvertModal(item) {
      this.convert = {};
      this.cheque = {};
      this.convertModal = true;
      this.selected = item;
    },
    expire() {
      this.expireBusy = true;
      Axios.patch(
        this.baseUrl +
          "/ppkpms/shop/sales/expireProforma/" +
          this.deletedItem.id,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.expireBusy = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.deleteDialog = false;
            this.getCustomerInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.expireBusy = false;
          this.toast(err.response.data, "error");
        });
    },
    submitConvert() {
      let current = moment(new Date()).format("jYYYY/jMM/jDD");
      if (this.selected.expirationDate < current) {
        this.toast("پیش فاکتور معتبر نمی باشد", "error");
      } else {
        this.busy = true;
        Axios.post(
          this.baseUrl + "/ppkpms/shop/sales/convertProforma",
          {
            shopInvoiceId: this.selected.id,
            type: this.convert.sellingType,
            paymentType: this.convert.paymentType,
            chequeNo:
              this.convert.paymentType == "cheque"
                ? this.cheque.number
                  ? this.cheque.number
                  : ""
                : undefined,
            chequeDate:
              this.convert.paymentType == "cheque"
                ? this.cheque.date
                  ? this.cheque.date
                  : ""
                : undefined,
            chequeSayyad:
              this.convert.paymentType == "cheque"
                ? this.cheque.chequeSayyad
                  ? this.cheque.chequeSayyad
                  : ""
                : undefined,
            chequeBank:
              this.convert.paymentType == "cheque"
                ? this.cheque.bankName
                  ? this.cheque.bankName
                  : ""
                : undefined,
            description: this.convert.description
              ? this.convert.description
              : "",
            buyerCardNumber:
              this.convert.paymentType == "cardTransfer"
                ? this.buyerCardNumber
                  ? this.buyerCardNumber
                  : ""
                : undefined,
            recipientCardNumber:
              this.convert.paymentType == "cardTransfer"
                ? this.recipientCardNumber
                  ? this.recipientCardNumber
                  : ""
                : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            this.busy = false;
            if (res.status == 201) {
              this.toast(res.data, "success");
              this.convertModal = false;
              this.getCustomerInfo();
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .catch((err) => {
            this.busy = false;
            this.toast(err.response.data, "error");
          });
      }
    },
    submitReturn() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/return",
        {
          shopInvoiceId: this.selected.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.returnModal = false;
            this.getCustomerInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.busy = false;
        });
    },
    paymentPrint(item) {
      this.gettingReceipt = true;
      this.receiptType = "payment";
      Axios.get(this.baseUrl + "/ppkpms/shop/payments/getInfo/" + item.id, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printPayment = res.data.income;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          this.printReceipt();
        })
        .catch((err) => {
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printInvoiceReceipt(item) {
      this.gettingReceipt = true;
      this.$router.push("/print/" + this.type + "/invoice/" + item.id);
    },
    printPreInvoice(item, type) {
      this.gettingReceipt = true;
      this.$router.push("/print/" + this.type + "/preinvoice/" + item.id);
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><link rel='stylesheet' href='/customreceipt.css'><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      if (this.receiptType == "total") {
        myWindow.document.write(
          document.getElementById("invoicesList").innerHTML
        );
      } else if (this.receiptType == "total2") {
        myWindow.document.write(
          document.getElementById("paymentsList").innerHTML
        );
      } else if (this.receiptType == "total3") {
        myWindow.document.write(
          document.getElementById("proformaList").innerHTML
        );
      } else if (this.receiptType == "payment") {
        myWindow.document.write(
          document.getElementById("paymentReceipt").innerHTML
        );
      }
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    getCustomerInfo() {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/getInfo",
        { shopCustomerId: this.$route.params.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          this.vLoading = false;
          if (res.status == 200) {
            this.customer = res.data;

            this.proformaTotalRows = this.customer.proformaInvoices.length;
            try {
              this.customer.type = this.customerTypes.filter(
                (x) => x.value == this.customer.type
              )[0].text;
            } catch (error) {
              this.customer.type = "-";
            }

            this.totalInvoice =
              this.customer.shopInvoices
                .filter((y) => y.status != "برگشت خورده")
                .map((x) => x.totalCost.split(",").join(""))
                .reduce((a, b) => Number(a) + Number(b), 0)
                .toLocaleString() + " ریال";

            this.invoicesTotalRows = this.customer.shopInvoices.filter(
              (y) => y.status != "برگشت خورده"
            ).length;

            this.totalPayment =
              this.customer.shopIncomes
                .filter((y) => y.status != "برگشت خورده")
                .map((x) => x.amount.split(",").join(""))
                .reduce((a, b) => Number(a) + Number(b), 0)
                .toLocaleString() + " ریال";

            this.incomesTotalRows = this.customer.shopIncomes.filter(
              (y) => y.status != "برگشت خورده"
            ).length;

            this.normalRoyaltyCreditAmount = Number(
              res.data.normalRoyaltyCreditAmount
            ).toLocaleString();
            this.vipRoyaltyCreditAmount = Number(
              res.data.vipRoyaltyCreditAmount
            ).toLocaleString();

            try {
              this.balance =
                this.customer.shopInvoices
                  .filter((y) => y.status != "برگشت خورده")
                  .map((x) => x.totalCost.split(",").join(""))
                  .reduce((a, b) => Number(a) + Number(b), 0) -
                this.customer.shopIncomes
                  .filter((y) => y.status != "برگشت خورده")
                  .map((x) => x.amount.split(",").join(""))
                  .reduce((a, b) => Number(a) + Number(b), 0);
              if (this.balance.toLocaleString() == this.customer.balance) {
                if (this.balance > 0) {
                  this.balance =
                    Math.abs(this.balance).toLocaleString() + " ریال بدهکار";
                } else if (this.balance < 0) {
                  this.balance =
                    Math.abs(this.balance).toLocaleString() + " ریال بستانکار";
                } else {
                  this.balance = "تسویه";
                }
              } else {
                this.balance = "خطا در محاسبات - با پشتیبانی تماس بگیرید";
              }
            } catch (error) {
              this.balance = "خطا در محاسبات - با پشتیبانی تماس بگیرید";
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
  },
  computed: {
    computedchequeInfo() {
      if (this.convert.paymentType == "cheque") {
        if (!this.cheque.number || !this.cheque.bankName || !this.cheque.date) {
          return true;
        } else return false;
      } else return false;
    },
    computedInvoiceCustomer() {
      let filtered;
      filtered = this.customer.shopInvoices.filter((x) =>
        x.invoiceCode
          .toLocaleLowerCase()
          .includes(this.filter.toLocaleLowerCase())
      );
      return filtered;
    },
    computedShopIncomes() {
      let filtered;
      filtered = this.customer.shopIncomes.filter(
        (x) =>
          x.amount.includes(this.filter) ||
          x.date.includes(this.filter) ||
          x.time.includes(this.filter) ||
          x.description.toLowerCase().includes(this.filter.toLowerCase()) ||
          x.status.includes(this.filter)
      );
      return filtered;
    },
    computedBtn() {
      if (!this.convert.sellingType) return true;
      if (this.convert.sellingType != "definite") return false;
      if (!this.convert.paymentType) return true;
      if (this.convert.paymentType == "cardTransfer") {
        if (!this.buyerCardNumber || !this.recipientCardNumber) return true;
      } else if (this.convert.paymentType == "cheque") {
        if (!this.cheque.number || !this.cheque.bankName || !this.cheque.date)
          return true;
      } else return false;
    },
  },
  mounted() {
    this.getCustomerInfo();
    this.userId = this.$route.params.id;
  },
};
</script>

<style>
* {
  font-family: iransans;
}

@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.v-select .v-input__slot fieldset {
  background-color: white !important;
}
.v-selectt .v-text-field__details {
  display: none !important;
}
</style>
<style scoped>
button.btn.btn-link {
  color: #1976d2 !important;
}
.mdi:before,
.mdi-set {
  margin-top: 2px !important;
}
.v-dialog {
  overflow-y: hidden !important;
}
</style>
